module.exports = __webpack_public_path__ + "static/third-d39a94fd2ad2c625279a804ef17e7a0a.svg";